import axios from '../../utils/axiosinstance'
import moment from 'moment'

const state = {
  opennav: {
    open: 0,
    mySidenav: -235,
    main: 0,
    MarginProperty: 0
  },
  editPhoto: null,
  isEditPhoto: null,
  isBottomNav: 0,
  canvasPhotos: [],
  allCanvasPhotos: [],
  isDetailView: 0,
  isSliderView: 0,
  isMainView: 1,
  isMapView: 0,
  photos: [],
  plans: [],
  RangeTo: 30,
  showSliderView: 0,
  RangeFrom: 1,
  slider_active_image: {},

  startDate: '',
  endDate: '',
  LStart: 1,
  LEnd: 1,
  page: 1,
  perpage: 50,
  total: 1,
  filtered: 0,
  length: 0,
  TPage: 1,
  imageDetails: {},
  tags: [],
  active_image: {},
  isEdit: false,
  detailsSelectedImages: [],
  isDetailsImagesSelectable: false,
  selectedPhotos: [],
  flagshighlight: {},
  canvasplan: {},
  meta: {
    minimumdate: '',
    maximumdate: ''
  },
  range: [],
  activefilters: {
    searchStringByName: false,
    searchStringByRunid: false,
    hasplans: false,
    hastags: false,
    hasdescription: false,
    plansKeys: false,
    tagCreaterKeys: false,
    tagselectionskeys: false,
    rectangle: false
  },
  filtersactive: false,
  gottoplan: null,
  refreshlist: false,
  currentModalPhoto: {
    runid:'',
    photodate_c:'',
  },
  flagbygps: false,
  flagpreviewbygps: false,
  removePlanFilter: false,
  restorePlanFilter: false,
  rectangleActive: false,
  planmodal: {},
  currentPhotoFilter: {},
  currentPhotoOrder: {},
  activeImageCopy: {},
  dirty: false,
  actionTrigger: [],
  tempPhotoEdit: false,
  rectangleprops: {}
}

const getters = {
  setNav: state => state.opennav,
  setBottomNav: state => state.isBottomNav,
  setDetailsView: state => state.isDetailView,
  setSliderView: state => state.isSliderView,
  setMapView: state => state.isMapView,
  setStartDates: (state, startDate) => (state.startDate = startDate),
  setEndDates: (state, endDate) => (state.endDate = endDate),
  setFlagHighlight: state => state.flagshighlight,
  setCanvasPlan: state => state.canvasplan,
  setActiveFilters: state => state.activefilters,
  setFiltersActive: state => state.filtersactive
}

const actions = {

  resetfilters({commit}, value) {

    commit('setActiveFilters',  {
      searchStringByName: false,
      searchStringByRunid: false,
      hasplans: false,
      hastags: false,
      hasdescription: false,
      plansKeys: false,
      tagCreaterKeys: false,
      tagselectionskeys: false,
      rectangle: false
    })
    this.filtersActive = false
  },

  filtersActive({commit}) {
    let tempvalue = false
    for (const [key, value] of Object.entries(state.activefilters)) {
      if(value == true) {
        tempvalue = true
      }
    }

    this.activefilters = tempvalue
    commit('setFiltersActive',  tempvalue)

  },

  async getPlans ({commit}, project_id) {
    let params = {}
    await axios.post(process.env.VUE_APP_BASE_AMF_URL + `getplans2&token=` + localStorage.sessiontoken, {
      'methodName': 'getPlansOfProject',
      'serviceName': 'ProjectdocuService',
      'parameters': [
        project_id,
        {
          'operands': [{
            'fieldname': 'state',
            'fieldvalue': '0',
            '_explicitType': 'com\\projectdocu\\PredicateOperandEQVO'
          }],
          '_explicitType': 'com\\projectdocu\\PredicateOperatorAndVO'
        },
        [{
          'fieldname': 'description',
          'order': 'ASC',
          '_explicitType': 'com\\projectdocu\\OrderSettingVO'
        }]
      ]
    },
    {
      headers: {
        apitoken: localStorage.apikey,
        deviceid: localStorage.deviceid,
        accept: 'application/json'
      }
    })
      .then(response => {
        let plains = []
        if (response.data.plans) {
          plains = response.data.plans.map(plans => {
            let tempPlans
            tempPlans = plans
            tempPlans.src = require('@/assets/images/map.png')
            return tempPlans
          })
        }
        commit('setPlans', plains)
      }).catch(e => {
        console.log(e)
      })
  },

  // Get Image Details
  async getImageDetails ({commit, dispatch }, payload) {
    // console.log('Photoid', payload)
    let url3 = `${process.env.VUE_APP_GET_METHOD_URL}img&projectid=${payload.id}&id=${payload.img_id}&token=${localStorage.sessiontoken}`
    let url_2 = `/project/${payload.id}/photo/${payload.img_id}/getdetails`

    let url = `${process.env.VUE_APP_BASE_AMF_URL}getPlansOfPhoto&token=${localStorage.sessiontoken}`
    await axios.post(url, {
      'methodName': 'getPlansOfPhoto',
      'serviceName': 'ProjectdocuService',
      'parameters': [
        payload.img_id
      ]
    },
    {
      headers: {
        apitoken: localStorage.apikey,
        deviceid: localStorage.deviceid,
        accept: 'application/json'
      }
    }).then(response => {
      // console.log('ResPhotoDetails', response.data)
      let data = response.data
      dispatch('getPlanImageFile', data)
    }).catch(e => {
      console.log(e)
    })
  },

  // Get Plan Image
  getPlanImageFile ({commit}, payload) {
    if (payload.plans) {
      payload.plans.forEach(async (value) => {
        let url = process.env.VUE_APP_BASE_URL + value.path + '&type=M&token=' + localStorage.sessiontoken
        // process.env.VUE_APP_BASE_URL + `/getfile/planimage/${value.id}/M`,
        await fetch(
          url,
          {
            headers: {
              apitoken: localStorage.apikey,
              deviceid: localStorage.deviceid
            }
          })
          .then(response => response.blob())
          .then(response => {
            let reader = new FileReader()
            reader.readAsDataURL(response)
            reader.onload = function () {
              value.src = reader.result
            }
          })
      })
      setTimeout(function () {
        commit('setImageDetails', payload)
      }, 2000)
    } else {
      commit('setImageDetails', payload)
    }
  },

  // Update Photo Description
  async updatePhotoDescription ({commit}, payload) {
    let url = `${process.env.VUE_APP_BASE_URL}project/${payload.id}/photo/${payload.photo_id}/update`
    url = process.env.VUE_APP_BASE_AMF_URL + `updatePhoto&token=` + localStorage.sessiontoken
    // console.log('params', payload)

    await axios.post(url, payload, {
      headers: {
        apitoken: localStorage.apikey,
        deviceid: localStorage.deviceid,
        accept: 'application/json'
      }
    }).then(res => {
      if (res.statusText == 'OK') {
        this._vm.$toast.success('Fotodaten aktualisiert', {
          timeout: 750
        })
        console.log(res)
      } else {
        this._vm.$toast.error('Oops... ! Some Thing Went Wrong')
      }
    })
  },

  // Update Photo Description
  updateMultiPhotoDescription ({commit, state}, payload) {
    let images = state.detailsSelectedImages

    // console.log('Images to update', images)

    let now = new Date()
    let _this = this

    let url = ''
    //`${process.env.VUE_APP_BASE_URL}project/${payload.id}/photo/${item.id}/update`
    url = process.env.VUE_APP_BASE_AMF_URL + `updatePhoto&token=` + localStorage.sessiontoken

    images.forEach(async (item) => {
      let tags = []

      if (item.description == null || !item.description) { item.description = '' }

      // let photoTags = item.tags.replace(/\"/g, '')
      if (payload.tagsOption == 'add') {
        if(Array.isArray(item.params)) {
          tags = item.params
        }
        payload.tags.forEach(function(val, idx) {
          let foundidx = tags.findIndex((singletag) => singletag.projectparamid == val.projectparamid)
          // console.log('FoundIdx', foundidx, tags[foundidx])
          if( foundidx >= 0 ) {
            // existiert bereits im Array
            tags.splice(foundidx, 1)
          }
          tags.push(val)
        })
      } else {
        if(Array.isArray(item.params)) {
          tags = item.params
        }
        payload.tags.forEach(function(val, idx) {
          let foundidx = tags.findIndex((singletag) => singletag.projectparamid == val.projectparamid)
          if( foundidx >= 0 ) {
            // existiert bereits im Array
            tags.splice(foundidx, 1)
          }
        })
        // remove tags
      }
      let description = item.description

      if(payload.option == 'add') {
        if(payload.description != '') {
          description = description + "\n" + payload.description
        }
      } else {
        description = payload.description
      }

      // description: payload.option == 'add' ? `${item.description} - ${payload.description}` : payload.description,
      let params = {
        description: description,
        tags: tags
      }
      item.description = params.description
      item.tags = params.tags

      let data = {
        methodName: 'UpdatePhoto',
        serviceName: 'ProjectdocuService',
        parameters: [
          item.pdphotoid,
          {
            pdphotoid: item.pdphotoid,
            projectid: item.projectid,
            description: item.description,
            // photodate: moment(String(item.photodate)).format('YYYY-MM-DD hh:mm:ss'),
            // dailydocu: item.dailydocu,
            // exifhasgps: item.exifhasgps,
            // exifgpsx: item.exifgpsx,
            // exifgpsy: item.exifgpsy,
            // exifdate: item.exifdate,
            // exifhasgpsdirection: item.exifhasgpsdirection,
            // exifgpsdirection: item.exifgpsdirection,
            // gpsaccuracy: item.gpsaccuracy,
            params: item.tags,
            savedate: moment(String(now)).format('YYYY-MM-DD hh:mm:ss'),
            _explicitType: "com\\projectdocu\\PhotoVO"
          }
        ]

      }


      await axios.post(url, data, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(res => {
        if (res.statusText !== 'OK') {
          this._vm.$toast.error(res.statusText)
        }
      }).catch((error) => {
        this._vm.$toast.error('Oops... ! Some Thing Went Wrong')
      })
    })
    this._vm.$toast.success('Beschreibung hinzugefügt', {
      timeout: 750
    })
  },

  // Rotate Single Photo
  async rotatePhoto ({commit}, payload) {
    // let url = `${process.env.VUE_APP_BASE_URL}/project/${payload.id}/photo/${payload.photo_id}/rotate`
    let url = process.env.VUE_APP_BASE_AMF_URL + `rotateSinglePhoto&token=` + localStorage.sessiontoken

    // console.log('RotateSingleFoto', payload)
    let data = {
      'methodName' : 'rotatePhotos',
      'parameters' : [[payload.pdphotoid], payload.rotateVal],
      'serviceName' : 'ProjectdocuService'
    }
    $('.spinner-cover').show()

    await axios.post(url, data, {
      headers: {
        apitoken: localStorage.apikey,
        deviceid: localStorage.deviceid,
        accept: 'application/json'
      }
    }).then(res => {
      $('.spinner-cover').hide()
      if (res.statusText == 'OK') {
        this._vm.$toast.success('Foto aktualisiert', {
          timeout: 750
        })
        // console.log('success', res)
      } else {
        this._vm.$toast.error('Oops... ! Some Thing Went Wrong')
      }
    })
  },

  // Rotate Multiple Photos
  async rotateMultiPhotos ({commit}, payload) {
    let url = ''
    // console.log('Rotate Multi Photos', payload)

    let photoids = []
    payload.photos.forEach(async (photo) => {
      photoids.push(photo.pdphotoid)
    })

      // url = `${process.env.VUE_APP_BASE_URL}/project/${payload.id}/photo/${photo.id}/rotate`

      url = process.env.VUE_APP_BASE_AMF_URL + `rotateMultiPhoto&token=` + localStorage.sessiontoken

      let data = {
        'methodName' : 'rotatePhotos',
        'parameters' : [photoids, payload.rotateVal],
        'serviceName' : 'ProjectdocuService'
      }
      await axios.post(url, data, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      })
      .then(res => {
        if (res.statusText != 'OK') {
          this._vm.$toast.error('Some thing went wrong...!')
        }
      })
      this._vm.$toast.success('Fotos rotiert', {
        timeout: 750
      })
  },

  // Delete Multiple Photos
  deleteMultiPhotos ({commit}, payload) {
    let url = ''
    let data = {}

    // console.log('Delete Multi Photo', payload)

    payload.photos.forEach(async (photo) => {
      // url = `${process.env.VUE_APP_BASE_URL}project/${payload.id}/photo/${photo.id}/delete`
      url = process.env.VUE_APP_BASE_AMF_URL + `deleteMultiPhoto&token=` + localStorage.sessiontoken
      data = {
        methodName: 'deletePhoto',
        parameters: [photo.pdphotoid],
        serviceName: 'ProjectdocuService'
      }
      await axios.post(url, data,
        {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(res => {
        if (res.statusText != 'OK') {
          this._vm.$toast.error('Oops... ! Some Thing Went Wrong')
        }
      })
    })
    this._vm.$toast.success('Fotos gelöscht', {
      timeout: 750
    })
  },

  // Delete Photo
  async deletePhoto ({commit, state}, payload) {
    // console.log('Delete Single Photoid', payload)
    let url = `${process.env.VUE_APP_BASE_URL}project/${payload.id}/photo/${payload.photo_id}/delete`
    url = process.env.VUE_APP_BASE_AMF_URL + `deletePhoto&token=` + localStorage.sessiontoken

    let data = {
      methodName: 'deletePhoto',
      parameters: [payload.pdphotoid],
      serviceName: 'ProjectdocuService'
    }

    await axios.post(url, data, {
      headers: {
        apitoken: localStorage.apikey,
        deviceid: localStorage.deviceid,
        accept: 'application/json'
      }
    }).then(res => {
      if (res.statusText === 'OK') {
        this._vm.$toast.success('Foto gelöscht', {
          timeout: 750
        })
      } else {
        this._vm.$toast.error('Oops... ! Some Thing Went Wrong')
      }
    })
  },

  // Get photos by ids after update or delete photos
  refreshPhotos ({state}) {



    state.detailsSelectedImages.forEach(async (photo) => {

      // console.log('RefreshPhoto:', photo)
      // process.env.VUE_APP_BASE_URL + 'getfile/photo/' + photo.id + '/450x450/4.5:4.5',
      fetch(
        `${process.env.VUE_APP_GET_METHOD_URL}img&projectid=${photo.pdprojectid}&id=${photo.pdphotoid}&token=${localStorage.sessiontoken}`,
        {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid
          }
        }
      )
        .then(response => response.blob())
        .then(response => {
          let reader = new FileReader()
          reader.readAsDataURL(response)
          reader.onload = function () {
            photo.src = reader.result
          }
        })
    })
  },

  hoverPhotos ({commit, state}, items) {
    if(items.length <= 0) {
      // remove highlights
      $('.photohover').removeClass('photohover');
    } else {
      // markPhotos
      items.forEach(function(val, idx) {
        $('#photoframe_' + val).addClass('photohover');
      })
    }

  },

  // setActiveImage({commit, dispatch }, payload) {
  setActiveSliderImageOnClick ({commit, state}, payload) {

    console.log('setActiveImageInPhotoJs', state, payload)

    if(payload.event) {
      console.log('Event Shift', payload.event.shiftKey)
      console.log('Event Ctrl', payload.event.ctrlKey)
      console.log('Event Meta', payload.event.metaKey)
    }
    console.log('ImgId', payload.imgid)
    console.log('Index', payload.index)
    console.log('BottomNav', state.isBottomNav)
    console.log('Active Image', state.active_image)
    console.log('Route ID', payload.route_id)
    console.log('lastClickedImage', payload.lastClickedImage)

    let index = payload.index
    let isEdit = payload.isEdit
    let imgId = payload.imgid
    let event = payload.event
    let route_id = payload.route_id
    let lastClickedImage = payload.lastClickedImage
    let selectedImages

    if(state.isBottomNav) {
      selectedImages = state.selectedPhotos
    } else {
      selectedImages = state.detailsSelectedImages
    }


    if( !isEdit && state.isBottomNav ) {

      console.log('IsBottomNav', imgId, index, event)

      // Action run if Shift is hold
      if (event && event.shiftKey ) {
        this.selectMultipleOnShiftKey(imgId, index, event)
        return
      }

      // if (event && !event.shiftKey) {
      //   this.lastClickedImage = event.target.getAttribute('data-index')
      //   console.log('Shift CLICK start set to', this.lastClickedImage)
      // }

      let subidex = selectedImages.findIndex((item) => item.pdphotoid == imgId.pdphotoid)
      if(subidex >= 0) {
        console.log('this.isSelecteAble V2', state.isBottomNav, subidex)
        selectedImages.push(imgId)
      }

      if ( (event && (event.ctrlKey || event.metaKey)) ) {
        selectedImages.push(state.active_image)
        state.isDetailsImagesSelectable = true
        // this.$store.commit('toggleDetailsImagesSelectable', true)
        this.multiselectOnControlKey(imgId, index, event, 'auto')
        return
      }

      // Stop if Shift, CTRL or CMD hold.
      if (event && ( event.shiftKey || event.ctrlKey || event.metaKey) ) {
        return
      }

      let idex = selectedImages.findIndex((item) => item.pdphotoid == imgId.pdphotoid)
      // let currentindex = index
      // if(currentindex == null) {
      //   currentindex = this.currentImage
      // }
      // this.setCurrentImageIndex(currentindex)
      console.log('SingleClick', imgId, index, event)
      selectedImages = []
      // let payload = { id: route_id, img_id: imgId.pdphotoid }
      // this.$store.dispatch('getImageDetails', payload)

      // let test = this.checkImg(imgId.pdphotoid) ? null : this.setImage(imgId.pdphotoid)
      // this.is_slider_set = true
      // this.$store.commit('setActiveImage', imgId)


      console.log('------------------------------------------ FINISHED FUNC ------------------------------------------');

      return
    }


  }

}

const mutations = {
  setPage(state, page) {
    console.log('Set Page', page)
    state.page = page
  },

  setTotalPages: (state, value) => {
    console.log('Set Total Pages', value)
    state.TPage = value
  },

  setEditPhoto: (state,payload) => {
    state.editPhoto = payload
  },
  setIsEditPhoto: (state,payload) => {
    state.isEditPhoto = payload
  },
  setSelectedPhotos: (state , payload) => { state.selectedPhotos = payload },

  refreshPhotosListByEdit: (state , payload) => { state.refreshlist = !state.refreshlist },

  setPlans: (state, payload) => { state.plans = payload },

  updatePhotoDetails: (state, payload) => {
    state.photos[payload.index].description = payload.params.description
    state.photos[payload.index].tags = payload.params.tags
  },
  setDetailsSelectedImages: (state, payload) => {
    state.detailsSelectedImages = payload
    if (state.detailsSelectedImages.length === 0) {
      state.isDetailsImagesSelectable = false
    }
  },
  setAllImages: (state, payload) => {
    state.photos = payload
  },

  setAllImagesForPhotoCanvas: (state, payload) => {
    state.canvasPhotos = payload
  },

  // All Photos In With Map View
  setAllCanvasPhotos: (state, payload) => {
    state.allCanvasPhotos = payload
  },

  setActiveImage: (state, payload) => {

    console.log('Set Active Image', payload)
    // Create coppy of object for roleback
    if(typeof state.activeImageCopy === 'object' && state.activeImageCopy.pdphotoid != payload.pdphotoid) {
      state.activeImageCopy = JSON.parse(JSON.stringify(payload))
    }

    state.active_image = payload
  },

  sliderActiveImage: (state, payload) => {
    state.slider_active_image = payload
  },
  toggleDetailsImagesSelectable: (state, payload) => {
    state.isDetailsImagesSelectable = payload
  },
  setImageDetails: (state, payload) => {
    state.imageDetails = payload
  },

  setNav: (state, value) => {
    if(value) {
      state.opennav.open = 0
    } else {
      state.opennav.open = 1
    }

    if (state.opennav.open) {
      state.opennav.open = 0
      state.opennav.mySidenav = '-229px'
      state.opennav.main = '0'
      state.opennav.MarginProperty = '0'
    } else {
      state.opennav.open = 1
      state.opennav.mySidenav = '0'
      state.opennav.MarginProperty = '210px'
      state.isBottomNav = 0
    }
  },

  imageSelectableToggle: (state) => {
    state.isBottomNav = !state.isBottomNav
    if(!state.isBottomNav) {
      state.isDetailsImagesSelectable = false
    }
  },

  imageSelectableToggleTrue: (state, val) => {
    state.isBottomNav = val
  },

  // TODO Filterleiste Funktion

  setDetailsView: (state) => {
    if (state.isDetailView) {
      state.isMainView = 1
      state.isDetailView = 0
      state.isMapView = 0
      state.opennav.open = 0
      state.isSliderView = 0
      state.opennav.mySidenav = '-228'
    } else {
      // TODO bei Klick auf Details
      state.isDetailView = 1
      state.isMainView = 0
      state.opennav.open = 0
      state.isMapView = 0
      state.isSliderView = 0
      state.opennav.mySidenav = '-228'
    }
  },

  setOverView: (state) => {
    if (state.isOverview) {
      state.isMainView = 0
      state.isDetailView = 0
      state.isMapView = 0
      state.opennav.open = 0
      state.isSliderView = 0
      state.opennav.mySidenav = '-228'
    } else {
      state.isDetailView = 0
      state.isMainView = 1
      state.opennav.open = 0
      state.isMapView = 0
      state.isSliderView = 0
      state.opennav.mySidenav = '-228'
    }
  },

  setSliderView: (state) => {
    if (state.isSliderView) {
      state.isSliderView = 0
      state.isDetailView = 1
    } else {
      state.isSliderView = 1
      state.isDetailView = 0
    }
  },

  toggleSliderView: (state) => {
    state.showSliderView = !state.showSliderView
  },

  setMapView: (state) => {
    if (state.isMapView) {
      state.isMainView = 1
      state.isMapView = 0
      state.isDetailView = 0
      state.opennav.open = 0
      state.isSliderView = 0
      state.opennav.mySidenav = '-228'
    } else {
      state.isMapView = 1
      state.isDetailView = 0
      state.isMainView = 0
      state.opennav.open = 0
      state.isSliderView = 0
      state.opennav.mySidenav = '-228'
    }
  },


  setStartDates: (state, startDate) => {
    // console.log('Commit STARTDATE', startDate)
    this.startDate = startDate
  },

  setEndDates: (state, endDate) => {
    // console.log('Commit ENDDATE', endDate)
    this.endDate = endDate
  },

  toggleEdit: (state, value) => {
    state.isEdit = value
    if (!state.isEdit) {
      state.isDetailsImagesSelectable = false
      state.detailsSelectedImages = []
    }
  },

  setflashHighlight: (state, photo) => {
    // console.log(state, photo)
    state.flagshighlight = photo
  },

  setCanvasPlan: (state, plan) => {
    // console.log('Set Canvas Plan', plan)
    state.canvasplan = plan
  },

  setActiveFilters: (state, value) => {
    state.activefilters = value
  },

  setFiltersActive: (state, value) => {
    state.filtersactive = value
  },

  setRectangleProps: (state, value) => {
    console.log('Set Rectangle Props', value)
    state.rectangleprops = value
  },


}
export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/photo.js